import { createSelector } from 'reselect';

const supplierProductsStateSelector = state => state.supplierProducts;
const selectById = (state, itemId) => itemId;

export const supplierProductsSelector = createSelector(
  [supplierProductsStateSelector],
  supplierProducts => supplierProducts.items
);

export const supplierProductByIdSelector = createSelector(
  [supplierProductsSelector, selectById],
  (supplierProducts, _id) => {
    const product = supplierProducts.find(item => _id === item._id);
    if (!product) return null;
    return product;
  }
);

export const supplierProductsIsLoadingSelector = createSelector(
  [supplierProductsStateSelector],
  supplierProducts => supplierProducts.isLoading
);

export const supplierProductsCountSelector = createSelector(
  [supplierProductsStateSelector],
  supplierProducts => supplierProducts.count
);

export const searchValueSelector = createSelector(
  [supplierProductsStateSelector],
  supplierProducts => supplierProducts.searchValue
);

export const suppliersProductsAsLabelAndValueSelector = createSelector(
  [supplierProductsSelector],
  suppliers =>
    suppliers.map(({ _id, name }) => ({
      value: _id,
      label: name
    }))
);
